import Cookies from 'js-cookie';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ChangePasswordModal from '../components/common/ChangePasswordModal';
import MainHeader from '../components/common/MainHeader';
import { Button, Layout, List, Typography, Space } from "antd";
import { LockFilled, UserOutlined, EditFilled, IdcardOutlined } from '@ant-design/icons';

const ProfileListItem = ({ icon, title, data }) => {

  const { Title } = Typography;
  const Icon = ({ icon }) => (
    <Space>
      {React.createElement(icon)}
    </Space>
  );

  return (
    <List.Item style={{ paddingTop: '2rem' }} >
      <Space>
        {icon && < Icon icon={icon} />}
        <Title level={5} >{title}</Title>
      </Space>
      <div style={{ marginLeft: '24px' }}>{data}</div>
    </List.Item>
  )
}

export default function UserProfileView() {

  const { Content } = Layout;
  const { Title } = Typography;
  const { t } = useTranslation();
  const [user] = React.useState(JSON.parse(Cookies.get('user', {})));
  const [isChangePasswordOpen, setIsChangePasswordOpen] = React.useState(false);

  return (

    <div>
      <MainHeader />
      <Layout style={{ alignItems: 'center' }}>
        <Content style={{ margin: '24px', marginTop: '7em' }} >
          <Title level={2} style={{ textAlign: 'center', marginBottom: '20px' }}>
            {t('menus.user_profile')}
          </Title>
          <List
            itemLayout="horizotal"
          >
            <ProfileListItem
              icon={UserOutlined}
              title={t('user_profiles.username')}
              data={user.username} />

            <ProfileListItem
              icon={EditFilled}
              title={t('user_profiles.full_name')}
              data={user.first_name && user.last_name ? `${user.first_name} ${user.last_name}` : '-'} />

            <ProfileListItem
              icon={IdcardOutlined}
              title={t('user_profiles.groups')}
              data={user.groups.length ? user.groups.toString() : '-'} />

            <ProfileListItem
              data={(
                <Button
                  color="primary"
                  variant="outlined"
                  icon={<LockFilled />}
                  onClick={() => setIsChangePasswordOpen(true)} >
                  {t('user_profiles.change_password')}</Button>
              )} />
          </List>
        </Content>
        <ChangePasswordModal
          open={isChangePasswordOpen}
          onClose={() => setIsChangePasswordOpen(false)} />
      </Layout>
    </div>

  )
}
